
//Imports
	//Libraries
  import { AxiosError } from 'axios';
  import { Component, Vue } from 'vue-property-decorator';
  // @ts-ignore
  import Switches from 'vue-switches';

  //Classes
  import { Setting } from '@/stores/Setting';
  import { showToaster } from '@/components/DashboardComposer/helpers';
  import { translate } from "../../helpers/functions";
  import axiosInstance from '../../helpers/axios';
  import stores from '@/stores';

  //Components
  import NevronHeader from '@/components/NevronHeader.vue';
  import Skeleton from '@/modules/Skeleton.vue';
  import Working from '@/modules/Working.vue';
  import TimeZones from '@/modules/TimeZones.vue';

//Component
  @Component(
    {
      methods: { translate },
      components:
      {
        NevronHeader,
        Skeleton,
        Switches,
        TimeZones,
        Working,
      },
    }
  )
  export default class PMSSetting extends Vue
  {
  //Defines
    protected static INTERFACE_TYPE_EMPTY: PMSInterface_type = 0;
    protected static INTERFACE_TYPE_FIAS: PMSInterface_type = 1;

    protected static INTERFACE_EMPTY: IPMSInterface =
      {
        id: -1,
        OID: -1,
        type: PMSSetting.INTERFACE_TYPE_EMPTY,
        title: '',
        backend_ip: '',
        backend_port: 0,
        backend_password: '',
        pms_ip: '',
        pms_port: 0,
        pms_port_encrypt: false,
        period_database_resync: 1440,
        period_disconnected_email: 0,
        period_keep_alive: 100,
        text_encoding: '',
        guest_adult_age: 0,
        language_OID_default: 0,
        language_selection: 2,
        timezone: '',
        specific: null
      };
    protected static INTERFACE_FIAS: IPMSInterface =
      {
        id: -1,
        OID: -1,
        type: PMSSetting.INTERFACE_TYPE_FIAS,
        title: '',
        backend_ip: 'nevron-offline-nhi2-service.nevron-app.svc.cluster.local',
        backend_port: 2000,
        backend_password: '',
        pms_ip: '',
        pms_port: 0,
        pms_port_encrypt: false,
        period_database_resync: 1440,
        period_disconnected_email: 0,
        period_keep_alive: 100,
        text_encoding: 'UTF-8',
        guest_adult_age: 18,
        language_OID_default: 1,
        language_selection: 2,   //All modern implementation use ISO 639-1 instead of Fidelio option.
        timezone: 'UTC',
        specific:
        {
          birthday_field: 'A0',
          birthday_format: 'yyyy-MM-dd',
          charges_filter_description: false,
          delay_database_resync: 0,
          delay_handshake: 5,
          keep_alive_message: 'LA',
          number_of_children_field: 'A1',
          posting_amount_without_cents: false,
          posting_convert_minibar_to_vod: false,
          posting_include_sales_outlet_in_minibar: false
        }
      };

  //Variables
    public languages: INHILanguage[] = [];

    public time_checkIn: ISetting = { key: 'default_pms_checkin_at', value: '14:00' };
    public time_checkOut: ISetting = { key: 'default_pms_checkout_at', value: '10:00' };

    public interface_data: IPMSInterface = PMSSetting.INTERFACE_EMPTY;
    public interface_type: PMSInterface_type = PMSSetting.INTERFACE_EMPTY.type;
    private interface_type_old: PMSInterface_type = PMSSetting.INTERFACE_EMPTY.type;

    public working: boolean = true;

  //Functions
    public async mounted(): Promise<void>
    {
      Vue.prototype.WebsiteTitle.setModuleName('analytic-configuration');

    //Load modules.
      this.working = true;

      await this.settings_load();
      await this.interface_load();

      this.working = false;
    }

  //-----------------------------------------------------------------------------------------------
    private async interface_load(): Promise<void>
    {
    //Get NHI's languages.
      const   languages = await stores.NHILanguage.items_load();    //Can NOT throw.

      if ( languages.error )
      {
        showToaster( "danger", "Request to retrieve NHI's languages failed.", languages.error );
        return;
      }

    //Filter out disabled languages.
      this.languages = languages.data!.filter(
        ( language: INHILanguage ): boolean =>
        {
        //Is it enabled?
          return ( !!language.enabled );
        }
      );

    //Get PMS interface configurations.
      const interface_data = await stores.PMSInterface.item_load();    //Can NOT throw.

      if ( interface_data.error )
      {
        showToaster( "danger", "Request to retrieve NHI's interface failed.", interface_data.error );
        return;
      }

    //Is interface defined?
    //
    //Notice:
    //If tenat's interface is not defined null will be returned.
      if ( !interface_data.data )
      {
      //Not defined or error -> ignore.
        return;
      }

    //Set interface.
      this.interface_data = interface_data.data!;
      this.interface_type = this.interface_type_old = interface_data.data!.type;
    }
    public async interface_insertUpdate(): Promise<void>
    {
    //Validate.
      if ( this.interface_data.type <= 0 )
      {
      //Invalid type -> ignore.
        return;
      }

    //Insert/Update interface.
      this.working = true;

      const   interface_data = await stores.PMSInterface.item_update( this.interface_data.id, this.interface_data );    //Can NOT throw.

      this.working = false;

      if ( interface_data.error )
      {
        showToaster( "danger", "Request to insert/update NHI's interface failed.", interface_data.error );
        return;
      }

    //Update interface.
    //
    //Why?
    //On insert/update interface values can change.
      this.interface_data = interface_data.data!;

    //Show success confirmation.
      showToaster( 'success', "NHI's interface succesfully inserted/updated.", "" );
    }

  //-----------------------------------------------------------------------------------------------
    private async settings_load(): Promise<void>
    {
    //Load PMS configurations.
      const settings_checkIn = await stores.Setting.getKeySetting( 'default_pms_checkin_at' )
      const settings_checkOut = await stores.Setting.getKeySetting( 'default_pms_checkout_at' )

      if ( settings_checkIn )
      {
      //CheckIn time.
        this.time_checkIn.value = settings_checkIn.value;
      }
      if ( settings_checkOut )
      {
      //CheckIn time.
        this.time_checkOut.value = settings_checkOut.value;
      }
    }
    public settings_update( checkAtItem: ISetting )
    {
    //Update single setting.
      this.working = true;

      stores.Setting.updateByKey( checkAtItem.key, checkAtItem )
        .then(
          (response: any) =>
          {
          //Show success confirmation.
            showToaster( 'success', "Setting succesfully updated.", "" );
          }
        ).finally(
          (): void =>
          {
            this.working = false;
          }
        );
    }

  //-----------------------------------------------------------------------------------------------
    public async type_onChange( event: any ): Promise<void>
    {
    //Initialize PMS values.
      switch ( parseInt( event.target.value ) )
      {
      case PMSSetting.INTERFACE_TYPE_EMPTY:
      {
      //Is interface defined?
        if ( this.interface_data.id <= 0 )
        {
        //No -> ignore.
          break;
        }

      //Are you sure?
        const result: any = await this.$swal.fire(
          {
            title: "Do you really want to delete PMS's interface data?",
            text: "This will stop and delete connection to PMS application.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete/stop it',
            cancelButtonText: 'Cancel'
          }
        );
        if ( !result.isConfirmed )
        {
        //Set back the type.
          this.interface_type = this.interface_type_old;
          
        //Stop any change.
          event.preventDefault();
          event.stopPropagation();
          break;
        }

      //Delete interface.
        this.working = true;

        const interface_data = await stores.PMSInterface.item_remove( this.interface_data.id, this.interface_data )    //Can NOT throw.

        this.working = false;

        if ( interface_data.error )
        {
          showToaster( "danger", "Request to delete NHI's interface failed.", interface_data.error );
          return;
        }

      //Reset interface config.
        this.interface_data = PMSSetting.INTERFACE_EMPTY;
        this.interface_type = this.interface_type_old = this.interface_data.type;

      //Show success confirmation.
        showToaster( 'success', "NHI's interface succesfully deleted.", "" );
        break;
      }
      case PMSSetting.INTERFACE_TYPE_FIAS:
      {
      //FIAS interface was selected -> define its settings.
        this.interface_data = JSON.parse( JSON.stringify( PMSSetting.INTERFACE_FIAS ) );    //Clone object.
        this.interface_type = this.interface_type_old = this.interface_data.type;

      //Generate interface password.
        this.password_generate();
        break;
      }
      }
    }

  //-----------------------------------------------------------------------------------------------
    public timezone_onChange( zone: string )
    {
    //Update timezone.
      this.interface_data.timezone = zone;
    }

  //-----------------------------------------------------------------------------------------------
    private password_generate()
    {
    //Generate new password.
    //
    //Notice:
    //NHI will not allow passwords that are less then 16 characters long.
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";

      for ( let i = 0; i < 16; i++ )
      {
        password += charset.charAt( Math.floor( Math.random() * charset.length ) );
      }

      this.interface_data.backend_password = password;
    }
    public async password_regenerate(): Promise<void>
    {
    //Do you really want to change the password?
      if ( this.interface_data.backend_password )
      {
      //Are you sure?
        const result: any = await this.$swal.fire(
          {
            title: 'Are you sure?',
            text: "This will replace the existing password (press Update to use it).",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, replace it',
            cancelButtonText: 'Cancel'
          }
        );
        if ( !result.isConfirmed )
        {
          return;
        }
      }

    //Generate password.
      this.password_generate();
    }
  }
